import axios from 'axios';
import makeDraggable from 'src/utilities/draggableDiv';
import { useEffect } from 'react';
import React from 'react';
import AxiosConfig from "src/utilities/AxiosConfig"

interface DLSMapProps {
    mapDetails: {
        dlsid: number;
        mapurl: string;
        ticketCount: number;
    } | null;
}

const DLSMap: React.FC<DLSMapProps> = ({ mapDetails }) => {

    const [showModal, setShowModal] = React.useState(false);
    const [canLoadMap, setCanLoadMap] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        const checkApiEndpoint = async () => {
            if (!mapDetails) {
                setCanLoadMap(false);
                return;
            }
            setLoading(true);
            try {
                const apiUrl = `${process.env.REACT_APP_ROUTING_API_URL}/api/Ticket/${mapDetails.dlsid}`;
                await axios.get(apiUrl, { ...AxiosConfig.configValue("min"), timeout: 5000 });
                setCanLoadMap(true);
            } catch (error) {
                console.log('api endpoint not reachable :( ', error);
                setCanLoadMap(false);
            } finally {
                setLoading(false);
            }
        };
        checkApiEndpoint();
    }, [mapDetails?.dlsid]);

    const handleCloseModal = () => setShowModal(false);
    const handleOpenModal = () => setShowModal(true);

    useEffect(() => {
        if (showModal) {
            const modalElement = document.getElementById('dls-map-content');
            if (modalElement) {
                makeDraggable(modalElement);
            }
        }
    }, [showModal]);

    const showDLSMapModal = () => {
        const mapURL = mapDetails?.mapurl?.replace('http://', 'https://') || "";
        return (
            <div id='dls-map-container'>
                <div id="dls-map-content" style={{ top: 50, left: 50 }}>
                    <div id='draggable-section' className="w-100 d-flex justify-content-end align-items-center">
                        <button className="action-text-danger material-icons" onClick={handleCloseModal}>
                            close
                        </button>
                    </div>
                    <div id="inner-map-div">
                        <iframe
                            key={mapURL}
                            src={mapURL}
                            style={{ zIndex: 5, border: 'none', borderRadius: 4}}
                            title="dls-map-frame"
                            id="map-iframe"
                        />
                    </div>
                </div>
            </div>
        );
    };

    if (!mapDetails) {
        return <div style={{ height: 400 }} className="center">No Map to Display</div>;
    }

    if (loading) {
        return <div style={{ height: 400 }} className="center">Checking Map Availability...</div>;
    }

    const mapURL = mapDetails.mapurl.replace('http://', 'https://');

    // API check failed — show "Load Map" button so map opens in modal instead of inline.
    if (!canLoadMap) {
        return (
            <>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <h5>DLSID: {mapDetails.dlsid}</h5>
                    <button
                        type="button"
                        onClick={handleOpenModal}
                        className="btn btn-sm btn-outline-primary"
                    >
                        Load Map
                    </button>
                </div>
                <div
                    style={{
                        height: 450,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#777777',
                        fontStyle: 'italic'
                    }}
                >
                    Click "Load Map" to view
                </div>
                {showModal && showDLSMapModal()}
            </>
        );
    }

    // API check successful — show map inline
    return (
        <>
            <div className="d-flex align-items-center justify-content-between">
                <h5>DLSID: {mapDetails.dlsid}</h5>
                <i
                    className="material-icons action-text ml-auto"
                    style={{ cursor: 'pointer' }}
                    onClick={handleOpenModal}
                >
                    fit_screen
                </i>
            </div>
            <iframe
                key={mapURL}
                id="route-iframe"
                className="w-100"
                title="dls-frame"
                style={{ height: 350, borderRadius: 4, border: 'none'}}
                src={mapURL}
            />
            {showModal && showDLSMapModal()}
        </>
    );
};

export default DLSMap;